module.exports = __webpack_public_path__ + "img/Success.9780467ab.svg";